export const waitForRouterHistory = (func: () => void, delay: number = 1): void => {
  setTimeout(async () => {
    func();
  }, delay);
};
